<template>
  <div>
    <table border="0">
      <thead>
        <tr>
          <th>Arquivo</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr class="contato" v-for="(item, index) of files" :key="item.id">
          <td>
            <div class="form-group required">
              <input
                class="form-control"
                type="file"
                :name="name + (nameSlotPrefix ? `[${nameSlotPrefix}-${item.id}]` : '[]')"
                accept="application/pdf, image/*"
                title="Adicionar"
              />
            </div>
          </td>
          <td class="actions">
            <a href="#" @click="insert_row" class="fa fa-plus-circle"></a>
            <a
              href="#"
              @click="remove_row($event, index)"
              class="fa fa-times-circle"
              v-if="files.length > 1"
              title="Remover"
            ></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: true
    },
    nameSlotPrefix: {
      required: false,
      default: ""
    }
  },
  data: () => ({
    files: [],
    table_id: 1
  }),
  methods: {
    insert_row(ev) {
      ev.preventDefault();
      this.files.push({ id: ++this.table_id });
    },
    remove_row(ev, index) {
      ev.preventDefault();
      this.files.splice(index, 1);
    }
  },
  mounted() {
    this.files.push({ id: this.table_id });
  }
};
</script>
<style lang="scss" scoped>
table {
  width: 100%;
}

.actions {
  a {
    color: #0d6e39;
    font-size: 20px;
  }
}
</style>
